"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("./styles");
// tslint:disable-next-line:no-var-requires
var styles = require('./style.css');
var kSections = [
    {
        heading: 'Bring your photos to life',
        text: [
            'Add the photos you\'ve taken on your adventures.',
            'Photos can be embedded direcly into your scenes so people can see what you saw as if they were there.',
        ].join(' '),
        image: 'studio-photos.png',
    },
    {
        heading: 'Customize scene playback',
        text: [
            'Want to zoom out to show off the scale of an ascent?',
            'Or switch to another track at just the right time?',
            'Set-up your scene just the way you want it to play with Ayvri Studio.',
        ].join(' '),
        image: 'segment-settings.png',
    },
    {
        heading: 'Everyone\'s adventures together',
        text: [
            'An Ayvri Pro account lets you add more than 3 tracks to a single scene.',
            'Great for watching all your friends and competitors together',
        ].join(' '),
        image: 'viewer-multitrack.png',
    },
];
exports.StudioPage = function (props) {
    var staticSrcPath = props.staticSrcPath;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.hero, style: { backgroundImage: "url('" + staticSrcPath + "/assets/images/backgrounds/studio_hero.png')" } },
            React.createElement("div", null,
                React.createElement("h2", null, "Unlock Ayvri's hidden magic with Studio"),
                React.createElement("h3", null, "Because our Pro members should have just as much fun as our API customers."),
                React.createElement("a", { href: '/settings/pro', className: styles.cta }, "Sign up to Pro"))),
        React.createElement("div", { className: styles_1.styles.promoGrid }, kSections.map(renderSection))));
    function renderSection(_a) {
        var heading = _a.heading, text = _a.text, image = _a.image;
        return (React.createElement("div", { key: "promosection:" + heading, className: styles_1.styles.promoSection },
            React.createElement("h2", null, heading),
            React.createElement("p", null, text),
            React.createElement("img", { src: staticSrcPath + "/assets/images/screenshots/" + image })));
    }
};
